import React, { Component, Fragment } from 'react'
import { ProgressBar } from 'primereact/progressbar';
import { AuthorizationService } from '../service/AuthorizationService';
import { ReportService } from '../service/ReportService';
import * as _ from 'lodash';
import { Button } from 'primereact/button';
import { Message } from 'primereact/message';
import { Accordion, AccordionTab } from 'primereact/accordion';

import { ReportCard } from './ReportCard';
import { LanguageService } from '../service/LanguageService';
import { FileService } from '../service/FileService';
import { ReportCardWithThumbnail } from './ReportCardWithThumbnail';
import { ReportCardWithThumbnailV2 } from './ReportCardWithThumbnailV2';

export class ClientDashboard extends Component {

    constructor() {
        super();
        this.state = {
            reports: [],
            loading: true,
            showOnlyFavorites: true
        };
        this.service = new ReportService();
        this.authorizationService = new AuthorizationService();
        this.languageService = new LanguageService();
        this.showGroups = false;
    }

    async componentDidMount() {
        
        const modules = this.authorizationService.getModules();
        const client = this.authorizationService.loggedInUser.client;
        if(this.authorizationService.getModules().find(m => m.id === 'REPORTS'))
        {
            // if(this.authorizationService.getModules().find(m => m.id === 'SUBSCRIPTION_PLANS'))
            // {
            //     if(client.config.signature_plans_home_enabled){
            //         console.log("loadPlansAndReports")
            //         await this.loadPlansAndReports();
            //     }
            //     else {
            //         console.log("loadReportsWithPlans")
            //         await this.loadReportsWithPlans();
                    
            //     }
            // }
            // else
            // {
                console.log("loadReports")
                await this.loadReports();
            // }
        }        
    }

    async loadPlansAndReports(){
        const plans = this.authorizationService.loggedInUser.plans || [];
        const thumbIds = [];
        for(let i = 0; i < plans.length; i++){
            for(let r = 0; r < plans[i].reports.length; r++){
                const thumbId = plans[i].reports[r].config.thumbnail;
                if(thumbId){
                    thumbIds.push(thumbId)
                }
            }
        }
        const thumbnails = thumbIds.length === 0 ? [] : await (new FileService()).listAll(thumbIds);
        await this.setState({loading: false, plans, thumbnails });
    }

    async loadReportsWithPlans(){
        const plans = this.authorizationService.loggedInUser.plans || [];
        const reports = this.authorizationService.loggedInUser.reports || [];

        console.log("plans", plans);

        for(let r = 0; r < reports.length; r++)
        {
            for(let i = 0; i < plans.length; i++)
            {
                const plan = plans[i];
                if(plan.reports.find(r1 => r1.id === reports[r].id))
                {
                    reports[r].plan = plan.id;
                }
            }
        }

        const thumbIds = [];
        reports.forEach(r => {
            const thumbId = r.config.thumbnail;
            if(thumbId){
                thumbIds.push(thumbId)
            }
        });

        console.log("reports", reports);

        // Listing groups
        const groups = [];
        for(let i = 0; i < reports.length; i++){
            if(groups.indexOf(reports[i].report_group) < 0){
                groups.push(reports[i].report_group);
            }
            console.log("group:" + reports[i].report_group);
        }
        console.log(groups);

        let showGroups = true;
        // if(window.location.search.indexOf("showgroups=1") >= 0){
        //    showGroups = true;
        // }


        const thumbnails = thumbIds.length === 0 ? [] : await (new FileService()).listAll(thumbIds);
        await this.setState({loading: false, plans, reports: reports.sort((a, b) => (a.config.order || 1000) > (b.config.order || 1000) ? 1 : -1), thumbnails, showGroups, groups });
    }

    async loadReports(){
        const reports = this.authorizationService.loggedInUser.reports || [];
        const thumbIds = [];
        for(let r = 0; r < reports.length; r++){
            const thumbId = reports[r].config.thumbnail;
            if(thumbId){
                thumbIds.push(thumbId)
            }
        }
        const thumbnails = thumbIds.length === 0 ? [] : await (new FileService()).listAll(thumbIds);

        const client = this.authorizationService.loggedInUser.client;
        if(client.config.newHome){
            const groups = [];
            for(let i = 0; i < reports.length; i++){
                if(groups.indexOf(reports[i].report_group) < 0){
                    groups.push(reports[i].report_group);
                }
            }
            let showGroups = true;
            await this.setState({
                loading: false, 
                reports: reports.sort((a, b) => (a.config.order || 1000) > (b.config.order || 1000) ? 1 : -1), 
                thumbnails,
                showGroups,
                groups
            });
        }
        else {
            await this.setState({
                loading: false, 
                reports, 
                thumbnails,
            });
        }
    }

    render() {        
        const { loading, reports, showOnlyFavorites, plans, thumbnails, showGroups, groups } = this.state;
        const reportsByGroups = _.groupBy(reports, (a) => a.report_group || "root");
        const client = this.authorizationService.loggedInUser.client;
        const favorites = (new AuthorizationService()).loggedInUser.favorites || [];
        const newHome = client.config.newHome || false;
        if(loading){
            return (
                <ProgressBar mode="indeterminate"/>
            );
        }
        else if(newHome){
            if(showGroups){
                return <>
                <Accordion multiple activeIndex={groups.map((g, i) => i)}>
                    
                {
                     groups.sort().map((g, iGroup) => 
                     
                        <AccordionTab  
                        key={`group_${iGroup}`} 
                        header={g} 
                        headerStyle={{ 
                            backgroundColor: 'none', 
                            border: 'none', 
                            color: client.custom_layout.primaryBackgroundColor, 
                            fontSize: '24px',
                            borderBottom: `1px solid ${client.custom_layout.primaryBackgroundColor}`,
                            fontWeight: 'bolder'
                        }}
                        contentStyle={{
                            backgroundColor: 'none'
                        }}
                        >
                        <div className="p-grid p-fluid dashboard">
                        { reports.filter(r => r.report_group === g).map((report,i) =>
                        <div key={`report_${i}`} style={{width: '450px', marginBottom: '40px', marginRight: '40px'}}>
                            <table style={{ width: '100%'}}>
                            <tbody>
                                <tr>
                                    <td>
                                        <h2 style={{ marginTop: '10px', marginRight: '100px', fontWeight: 'bolder', color: client.custom_layout.primaryBackgroundColor }}>
                                        { report.name }
                                        </h2>
                                    </td>
                                    { false && !report.has_access && <td style={{width: '110px'}}>
                                        
                                        <Button label={"Assine Agora"} className="p-button-text" 
                                            style={{ fontSize: '12px', color: '#fff', backgroundColor: client.custom_layout.primaryButtonColor, borderColor: client.custom_layout.primaryButtonColor}}
                                            onClick={() => {
                                            const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
                                            window.location.href = `${client && !client.use_custom_url ? `/${client.shortcode}` : ''}/subscriptions/plans?p=${ report.plan }`;
                                        }} />
                                    </td>}
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                    <ReportCardWithThumbnailV2 hideTitle={true} report={report} client={this.props.client} thumbnail={report.config.thumbnail ? thumbnails.find(t => t.id === report.config.thumbnail) : null}/>
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                            
                        </div>                    
                    )}
                    </div></AccordionTab>)
                }
                </Accordion>
                </>
            }
            else 
            {
                return <div className="p-grid p-fluid dashboard" style={{ }}>
                    { reports.map((report,i) =>
                        <div key={`report_${i}`} style={{width: '450px', marginBottom: '40px', marginRight: '40px'}}>
                            <table style={{ width: '100%'}}>
                            <tbody>
                                <tr>
                                    <td>
                                        <h2 style={{ marginTop: '10px', marginRight: '100px', fontWeight: 'bolder', color: client.custom_layout.primaryBackgroundColor }}>
                                        { report.name }
                                        </h2>
                                    </td>
                                    { !report.has_access && <td style={{width: '110px'}}>
                                        
                                        <Button label={"Assine Agora"} className="p-button-text" 
                                            style={{ fontSize: '12px', color: '#fff', backgroundColor: client.custom_layout.primaryButtonColor, borderColor: client.custom_layout.primaryButtonColor}}
                                            onClick={() => {
                                            const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
                                            window.location.href = `${client && !client.use_custom_url ? `/${client.shortcode}` : ''}/subscriptions/plans?p=${ report.plan }`;
                                        }} />
                                    </td>}
                                </tr>
                                <tr>
                                    <td colSpan={2}>
                                    <ReportCardWithThumbnailV2 hideTitle={true} report={report} client={this.props.client} thumbnail={report.config.thumbnail ? thumbnails.find(t => t.id === report.config.thumbnail) : null}/>
                                    </td>
                                </tr>
                            </tbody>
                            </table>
                            
                        </div>                    
                    )}
                </div>
            }
        }
        else if(this.props.force || (client.config.signature_plans_home_enabled && this.authorizationService.getModules().find(m => m.id === 'REPORTS') && this.authorizationService.getModules().find(m => m.id === 'SUBSCRIPTION_PLANS') && (plans || []).length > 0)){
            return <div className="p-grid p-fluid dashboard" style={{ }}>
                { plans.map((plan,i) =><>
                    <div key={`plan_${i}`} className="p-col-12 p-lg-12">
                        <table>
                            <tr>
                                <td><h2 style={{ marginTop: '10px', marginRight: '100px', fontWeight: 'bolder', color: client.custom_layout.primaryBackgroundColor }}>{ plan.isFree ? this.languageService.getText("Free") : plan.name }</h2></td>
                                <td>{ plan.isFree ? "" : plan.subscribed ? "" : 
                                    
                                    <Button label={"Assine Agora"} className="p-button-text" 
                                        style={{ fontSize: '12px', color: '#fff', backgroundColor: client.custom_layout.primaryButtonColor, borderColor: client.custom_layout.primaryButtonColor}}
                                        onClick={() => {
                                        const loggedInUser = JSON.parse(localStorage.getItem("loggedInUser") || "{}");
                                        window.location.href = `${client && !client.use_custom_url ? `/${client.shortcode}` : ''}/subscriptions/plans?p=${ plan.id }`;
                                    }} />
                                    }
                                </td>
                            </tr>
                        </table>
                    </div>
                    { (plan.reports || []).map((report, ireport) => <> 
                        <ReportCardWithThumbnail key={`plan_${plan.id}_${ireport}`} report={report} client={this.props.client} thumbnail={report.config.thumbnail ? thumbnails.find(t => t.id === report.config.thumbnail) : null}/>
                        </>
                    )}
                    </>
                )}
            </div>
        }
        else {    
            return (
                <>
                    <div className="p-grid p-fluid dashboard">
                    
                        { 
                            showOnlyFavorites && favorites.length > 0 ?
                                <>
                                    <div className="p-col-12 p-lg-12">
                                        <h2>{this.languageService.getText("My Favorites")}</h2>
                                    </div>

                                    { favorites.length === 0 && <div className="p-col-12 p-lg-12">
                                        <Message severity="warn" text={this.languageService.getText("No_Favorites_Message")}/>
                                    </div>}
                                    

                                    { (reports || []).filter(r => favorites.indexOf(r.id) >= 0).map((report, ireport) => 
                                        <ReportCard key={`favs_${ireport}`} report={report} client={this.props.client}/>
                                    )}
                                </>
                            :
                                <>
                                    { (reportsByGroups.root || []).map(report => 
                                        <ReportCard report={report} client={this.props.client}/>  
                                    )}

                                    {
                                        (Object.keys(reportsByGroups) || []).filter(l => l !== "root").map((label,igroup) => 
                                            <span key={`${igroup}`} className="p-grid p-fluid">
                                            <div className="p-col-12 p-lg-12">
                                                <h2>{label}</h2>
                                            </div>
                                            { (reportsByGroups[label] || []).map((report, ireport) => 
                                                <ReportCard key={`${igroup}_${ireport}`} report={report} client={this.props.client}/>
                                            )}
                                            </span>
                                        )
                                    }
                                </>
                        }
                    </div>
                    { favorites.length > 0 && <Button label={showOnlyFavorites ? this.languageService.getText("Show_All") : this.languageService.getText("Show_Only_Favorites")} className="p-button-text" onClick={() => this.setState({ showOnlyFavorites: !showOnlyFavorites })} /> }
                </>
            );
        }
    }
}